import Vegetal from "../components/Vegetal";
import Popular from "../components/Popular";

import React from 'react'

function Home() {
  return (
    <div>
        
    </div>
  )
}

export default Home